import { useSeo } from "@/hooks/useSeo";
import { PageHero, CTABand } from "@/components/Layout";
import { ProjectGallery } from "@/components/Sections";
import { business } from "@/data/site";

const Projects = () => {
  useSeo({
    title: `Before & After Projects — Our Work in New York | ${business.name}`,
    description: "Browse before-and-after photos of our completed plumbing, electrical, and HVAC projects across New York. Real transformations, real results.",
  });

  return (
    <>
      <PageHero eyebrow="Our Work" title="Before & After Projects" subtitle="Proof beats promises. Drag the sliders to see the transformations we've delivered for New York homeowners — filter by service type." />
      <section className="max-w-7xl mx-auto px-4 py-16 sm:py-24" data-testid="projects-gallery">
        <ProjectGallery />
      </section>
      <CTABand heading="Want Results Like These?" sub="Request a free estimate and let's transform your home next." />
    </>
  );
};

export default Projects;
